
import { defineComponent, PropType } from "vue";

interface RadioOption {
  label: string;
  value: string;
}

export default defineComponent({
  name: "EpxEmsRadio",

  props: {
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<RadioOption[]>,
      required: true,
    },
  },

  emits: {
    "update:modelValue": (value: string) => typeof value === "string",
  },

  setup(props, { emit }) {
    const onChange = (value: string) => {
      if (value !== props.modelValue) {
        emit("update:modelValue", value);
      }
    };

    return {
      onChange,
    };
  },
});
